import { safeInternalPath } from "./conversionJourney";

export const SDLE_SALES_ENTRY = "sdle_sales";
const CAMPAIGN_SESSION_KEY = "cshaped_sdle_sales_entry_v1";
const CAMPAIGN_CONTEXT_KEY = "cshaped_sdle_sales_context_v1";

export type SdleSalesLanguage = "en" | "ar";
export type SdleSalesIntent = "preparation" | "question_bank" | "mock_exam";

export interface SdleSalesContext {
  language: SdleSalesLanguage;
  intent: SdleSalesIntent;
}

const isSdleSalesIntent = (value: string | null): value is SdleSalesIntent =>
  value === "preparation" || value === "question_bank" || value === "mock_exam";

export function getSdleSalesContext(search = window.location.search): SdleSalesContext {
  const params = new URLSearchParams(search);
  const intent = params.get("intent");
  const explicitContext: SdleSalesContext = {
    language: params.get("lang") === "ar" ? "ar" : "en",
    intent: isSdleSalesIntent(intent) ? intent : "preparation",
  };

  try {
    if (params.get("entry") === SDLE_SALES_ENTRY) {
      window.sessionStorage.setItem(CAMPAIGN_CONTEXT_KEY, JSON.stringify(explicitContext));
      return explicitContext;
    }

    const stored = JSON.parse(window.sessionStorage.getItem(CAMPAIGN_CONTEXT_KEY) || "null");
    if (stored?.language === "ar" || stored?.language === "en") {
      return {
        language: stored.language,
        intent: isSdleSalesIntent(stored.intent) ? stored.intent : "preparation",
      };
    }
  } catch { }

  return explicitContext;
}

export function activateSdleSalesEntry(search = window.location.search): boolean {
  try {
    const isExplicitEntry = new URLSearchParams(search).get("entry") === SDLE_SALES_ENTRY;
    if (isExplicitEntry) {
      window.sessionStorage.setItem(CAMPAIGN_SESSION_KEY, "1");
      return true;
    }
    return window.sessionStorage.getItem(CAMPAIGN_SESSION_KEY) === "1";
  } catch {
    return new URLSearchParams(search).get("entry") === SDLE_SALES_ENTRY;
  }
}

export function withSdleSalesEntry(path: string, context?: Partial<SdleSalesContext>): string {
  const safePath = safeInternalPath(path) || "/qbank";
  const url = new URL(safePath, window.location.origin);
  url.searchParams.set("entry", SDLE_SALES_ENTRY);
  if (context?.intent) url.searchParams.set("intent", context.intent);
  if (context?.language) url.searchParams.set("lang", context.language);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function premiumPlusPath(returnTo: string): string {
  const params = new URLSearchParams({
    plan: "premium_plus",
    entry: SDLE_SALES_ENTRY,
  });
  const safeReturn = safeInternalPath(returnTo);
  if (safeReturn) {
    params.set("return_to", safeReturn);
    const returnUrl = new URL(safeReturn, window.location.origin);
    const language = returnUrl.searchParams.get("lang");
    if (language === "en" || language === "ar") params.set("lang", language);
  }
  return `/pricing?${params.toString()}`;
}

export function specialtySlug(value?: string | null): string {
  return String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
}
